module.exports = __webpack_public_path__ + "media/colleges/college_search_cta-7db3830e.png";